import { Box, Switch, Typography } from "@mui/material";

function MonthlyDayPicker(props) {
  const { day, setDay } = props;
  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Typography variant="subtitle1" color="grey.3" align="center">
        در کدام روز از ماه می‌خواهید پس‌انداز خودکار انجام شود؟
      </Typography>
      <Box
        sx={{
          mt: "12px",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          maxWidth: 264,
        }}
      >
        {Array.apply(null, Array(28)).map((_, index) => {
          const isActive = day === index + 1;
          return (
            <Box
              onClick={() => {
                setDay(index + 1);
              }}
              sx={{
                my: "4px",
                mx: "2px",
                minWidth: 40,
                minHeight: 40,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "16px",
                bgcolor: isActive ? "primary.main" : "common.white",
                border: (theme) => `1px solid ${theme.palette.grey[5]}`,
              }}
            >
              <Typography
                variant="body1"
                color={isActive ? "common.white" : "grey.2"}
              >
                {index + 1}
              </Typography>
            </Box>
          );
        })}
      </Box>
      <Box
        sx={{
          maxWidth: 264,
          mt: "24px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="body2" color="grey.2">
          انتخاب روز آخر ماه
        </Typography>
        <Switch
          checked={day === 100}
          onChange={(event) => {
            event.target.checked ? setDay(100) : setDay(1);
          }}
        />
      </Box>
    </Box>
  );
}

export default MonthlyDayPicker;
